const cleanupCartPrintContent = () => {

	document.body.classList.remove('printMode');

	const tempDiv = document.getElementById('printSection');
	if (tempDiv) {

		tempDiv.remove();

	}

};

export default cleanupCartPrintContent;
